import React, { useState, useEffect, useMemo } from 'react'
import _, { get } from 'lodash'
import { Container, ErrorContainer } from './index.styled'
import Wrapper, { ARStatus } from './wrapper'
import ClientBasicInfoSection from './Sections/ClientBasicInfoSection'
import PersonalInfoSection from './Sections/PersonalInfoSection'
import PageLoading from '../../components/UI/status/loading'
import IntroductionSection from './Sections/IntroductionSection'
import LifestyleSection from './Sections/LifestyleSection'
import HSDSummarySection from './Sections/HSDSummarySection'
import AerobicFitnessSection from './Sections/AerobicFitnessSection'
import MuscleSection from './Sections/MuscleSection'
import BalanceSection from './Sections/BalanceSection'
import RecommendationSection from './Sections/RecommendationSection'
import CognitiveHealthSection from './Sections/CognitiveHealthSection'
import MovementQualitySection from './Sections/MovementQualitySection'
import LifeStylePresentation from './Sections/LifeStylePresentation/LifeStylePresentation'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Button } from 'antd'
import { Footer } from '../../components/assessmentReview/draft'
import { SimpleUploadIcon, ViewIcon } from '../../components/icons'
import BodyCompResult from './Sections/BodyCompSection'
import Cardiometabolic from '../../components/assessmentReview/comp/cardiometabolic'
import { getRole } from '../../utils'
export const PAGE_ID = 'PhysicalAssessment'

export default Wrapper(PhysicalAssessment)

function PhysicalAssessment(props) {
  const {
    editingCount,
    list,
    person,
    loginRole,
    arDetail,
    device_info,
    residence,
    latest_height,
    latest_weight,
    dynamicData,
    routeTypes,
    jumpToDataset,
    handleSave,
    handlePublish,
    handlePreview,
    showActivity,
    ageScopes,
    currentLoadIndex,
    needDynamicLoadSections,
    next,
    hideSectionHandle,
    hideSection,
    createdFailed,
    handleCommendSave,
    onUpdateReferral,
    updateArDetail,
    HandleSaveScore,
    handleToSetDraft,
    trendMetrics,
    exerciseRecommendationPlots,
    copilotDashboard
  } = props

    const isBloodSamplesRequired = person && person.profile.blood_samples_required    
    const previous = get(dynamicData, 'healthSpanDomainSummary.1', {})
    const latest = get(dynamicData, 'healthSpanDomainSummary.0', {})
    const role = getRole()
  
  const getDataList = (snapshot, graph_type) => {
    return list.map((item) => {
      const detail =
        (snapshot[item.type] && _.cloneDeep(snapshot[item.type])) || {}
      detail.isDefaultValue = true
      if (detail.score_manual && detail.score_manual.value) {
        detail.isDefaultValue = false
      }
      return {
        ...item,
        ...detail
      }
    })
  }

  const compareData = getDataList(
    get(dynamicData, 'healthSpanDomainSummary.1.snapshot', {}),
    'previous'
  )
  const dataList = getDataList(
    get(dynamicData, 'healthSpanDomainSummary.0.snapshot', {}),
    'latest'
  )

  let [catchEditScore, setCatchEditScore] = useState([])
  const [scoresLegalCheck, serScoresLegalCheck] = useState({})

  const saveBulk = async (catchData) => {
    await HandleSaveScore(catchData || catchEditScore)
    setCatchEditScore([])
  }

  const save = async (type, setToDefaultValue) => {
    if (setToDefaultValue) {
      await saveBulk([
        {
          type,
          score: null,
          graph_type: 'latest'
        },
        {
          type,
          score: null,
          graph_type: 'previous'
        }
      ])
    } else if (catchEditScore.length) {
      await saveBulk()
    }
  }
  const onScoreChangeHandle = (score, type, graph_type) => {
    score = score || null
    let targetIndex = catchEditScore.findIndex(
      (item) => item.type === type && item.graph_type === graph_type
    )
    const scoreLegal = score ? score >= 5 && score <= 99 : true
    const scoreKey = type + graph_type
    scoresLegalCheck[scoreKey] = scoreLegal

    if (targetIndex !== -1) {
      catchEditScore[targetIndex].score = score
    } else {
      catchEditScore.push({
        type,
        graph_type,
        score
      })
    }
    setCatchEditScore(catchEditScore)
    serScoresLegalCheck(scoresLegalCheck)
  }
  const cancelEdit = (type) => {
    if (type) {
      catchEditScore = catchEditScore.filter((item) => item.type !== type)
      setCatchEditScore(catchEditScore)
    } else {
      setCatchEditScore([])
    }
  }

  useEffect(() => {
    // Scroll to the top after first loaded
    window.scrollTo(0, 0)
  }, [])

  const commonProps = {
    hideSectionHandle,
    hideSection,
    arDetail,
    person,
    onScoreChangeHandle,
    cancelEdit,
    dynamicData,
    loginRole,
    view: props.view,
    handleCommendSave: props.handleCommendSave
  }

  const editabled = useMemo(() => props.view === 'Draft', [props.view])

  return arDetail ? (
    <InfiniteScroll
      dataLength={currentLoadIndex + 1}
      next={next}
      hasMore={currentLoadIndex + 1 < needDynamicLoadSections.length}
      loader={
        <h4
          style={{
            paddingBottom: 75,
            fontSize: 24,
            textAlign: 'center',
            color: '#4C6072'
          }}
        >
          Loading...
        </h4>
      }
      endMessage={
        <p style={{ textAlign: 'center' }}>
          <b>Yay! You have seen it all</b>
        </p>
      }
    >
      <Container id={PAGE_ID}>
        <ClientBasicInfoSection
          editabled={editabled}
          person={person}
          arDetail={arDetail}
          onUpdateNotes={handleCommendSave}
        />
        <IntroductionSection
          notes={arDetail.notes}
          editabled={editabled}
          handleCommendSave={props.handleCommendSave}
        />
        <PersonalInfoSection
          {...{
            person,
            latest_height,
            latest_weight,
            device_info,
            residence
          }}
        />
        {_.has(dynamicData, 'lifeStyleSummary') && (
          <LifestyleSection
            {...commonProps}
            data={_.get(dynamicData, 'lifeStyleSummary', {})}
            notes={arDetail.notes}
            handleCommendSave={props.handleCommendSave}
            editabled={editabled}
          />
        )}
        {_.has(dynamicData, 'healthSpanDomainSummary') && (  
          <HSDSummarySection
            {...commonProps}
            data={_.get(dynamicData, 'healthSpanDomainSummary', {})}
            notes={arDetail.notes}
            handleCommendSave={props.handleCommendSave}
            person={person}
            editabled={editabled}
          />          
        )}
         { isBloodSamplesRequired && _.has(dynamicData, 'cardiometabolicHealth') && (            
           <Cardiometabolic
            {...commonProps}
            {...{
              previous,
              latest,
              save,
              handleSave,
              trendMetrics
            }}
            />        
        )}
        {_.has(dynamicData, 'aerobicFitness') && (
          <AerobicFitnessSection
            {...commonProps}
            {...{
              ageScopes,
              compareData,
              dataList,
              routeTypes,
              jumpToDataset,
              save,
              handleSave
            }}
            data={_.get(dynamicData, 'aerobicFitness', {})}
          />
        )}

        {_.has(dynamicData, 'bodyComposition') && (
          <BodyCompResult
            {...commonProps}
            {...{
              bodyCompResults: dynamicData.bodyComposition,
              ageScopes,
              compareData,
              dataList,
              routeTypes,
              jumpToDataset,
              save,
              handleSave
            }}
            data={_.get(dynamicData, 'bodyComposition', {})}

          />
        )}

        {_.has(dynamicData, 'muscleStrength') && (
          <MuscleSection
            {...commonProps}
            {...{
              ageScopes,
              compareData,
              dataList,
              routeTypes,
              jumpToDataset
            }}
            data={_.get(dynamicData, 'muscleStrength', {})}
          />
        )}

        {_.has(dynamicData, 'movementQuality') && (
          <MovementQualitySection
            {...commonProps}
            {...{
              ageScopes,
              compareData,
              dataList,
              routeTypes,
              jumpToDataset
            }}
            data={_.get(dynamicData, 'movementQuality', {})}
          />
        )}

        {_.has(dynamicData, 'balance') && (
          <BalanceSection
            {...commonProps}
            {...{
              ageScopes,
              compareData,
              dataList,
              routeTypes,
              jumpToDataset
            }}
            data={_.get(dynamicData, 'balance', {})}
          />
        )}

        {_.has(dynamicData, 'cognitiveHealth') && (
          <CognitiveHealthSection
            {...commonProps}
            {...{
              save,
              compareData,
              dataList,
              ageScopes
            }}
            data={_.get(dynamicData, 'cognitiveHealth', {})}
          />
        )}
        {(currentLoadIndex === needDynamicLoadSections.length - 1 ||
          needDynamicLoadSections.length === 0) && (
          <>
            <LifeStylePresentation
              {...commonProps}
              arDetail={arDetail}
              person={person}
              lsd={_.get(dynamicData, 'lifeStyleSummary', {})}
              editabled={editabled}
              handleCommendSave={handleCommendSave}
            />
            <RecommendationSection
              {...commonProps}
              person={person}
              lsd={_.get(dynamicData, 'lifeStyleSummary', {})}
              hsd={_.get(dynamicData, 'healthSpanDomainSummary', {})}
              editabled={editabled}
              arDetail={arDetail}
              onUpdateNotes={handleCommendSave}
              onUpdateReferral={onUpdateReferral}
              updateArDetail={updateArDetail}
              exerciseRecommendationPlots={exerciseRecommendationPlots}
              copilotDashboard={copilotDashboard}
            />
          </>
        )}
        {footer()}
      </Container>
    </InfiniteScroll>
  ) : createdFailed ? (
    <ErrorContainer>
      <span className="message">{createdFailed}</span>
      <Button
        type="primary"
        onClick={() => {
          props.history.goBack()
        }}
      >
        Back
      </Button>
    </ErrorContainer>
  ) : (
    <PageLoading />
  )

  function footer() {
    return (
      <Footer id="footer-preview">
        <div>
          {props.view === 'Preview' && arDetail.status === ARStatus.draft && (
            <Button
              ghost
              type="primary"
              onClick={() => handleSave(null, 'edit')}
            >
              BACK TO EDIT
            </Button>
          )}
          {props.view === 'Draft' && arDetail.status === ARStatus.draft && (
            <Button
              ghost
              type="primary"
              onClick={() => handleSave()}
              disabled={editingCount > 0}
            >
              SAVE AS DRAFT
            </Button>
          )}

        {role !== 'User' && (
          <Button
            ghost
            type="primary"
            disabled={editingCount > 0}
            onClick={() => showActivity()}
          >
            ACTIVITY
          </Button>
        )}

        </div>
        <div>
          {props.view === 'Draft' && arDetail.status === ARStatus.draft && (
            <>
              <Button
                ghost
                type="primary"
                onClick={handlePreview}
                disabled={editingCount > 0}
              >
                <ViewIcon />
                PREVIEW
              </Button>
              <Button
                type="primary"
                onClick={handlePublish}
                disabled={editingCount > 0}
              >
                <SimpleUploadIcon />
                PUBLISH
              </Button>
            </>
          )}
          {props.view === 'Preview' && arDetail.status === ARStatus.published && (
            <Button ghost type="primary" onClick={handleToSetDraft}>
              BACK TO EDIT
            </Button>
          )}
        </div>
      </Footer>
    )
  }
}
